import { STEPS } from './ConfigureAggregationsV2.const';
import Topic from './Topic';

class Form {
  constructor() {
    this.shared = {
      selectedNames: []
    };
  }

  onSelectScopes(scopes, setState) {
    this.shared.scopes = scopes;
    setState(this.nextState());
  }
  onSelectForm(form, setState) {
    this.shared.form = form;
    setState(this.nextState());
  }

  onSelectTopics(topics, setState) {
    this.shared.topics = [];
    for (const topic of topics) {
      this.shared.topics.push(new Topic(topic, this.shared));
    }

    setState(this.nextState());
  }

  nextState() {
    if (!this.shared.scopes) {
      return {
        step: STEPS.CHOOSE_SCOPE,
        stepProps: {
          onComplete: this.onSelectScopes.bind(this)
        }
      };
    }
    if (!this.shared.form) {
      return {
        step: STEPS.SELECT_FORM,
        stepProps: {
          onComplete: this.onSelectForm.bind(this)
        }
      };
    }
    if (!this.shared.topics || this.shared.topics.length === 0) {
      return {
        step: STEPS.CHOOSE_TOPICS,
        stepProps: {
          onComplete: this.onSelectTopics.bind(this)
        }
      };
    }
    for (const topic of this.shared.topics) {
      if (!topic.isComplete()) {
        return topic.nextState();
      }
    }
    return {
      step: STEPS.REVIEW,
      stepProps: {
        // onComplete: PropTypes.func.isRequired,
        // mapping: PropTypes.object.isRequired,
        // selectedForm: PropTypes.object.isRequired,
        // musts: PropTypes.object.isRequired,
        // scopes: PropTypes.array.isRequired
        onComplete: (setState) => {
          this.shared = {};
          setState(this.nextState());
        },
        mapping: this.shared.topics.map((d) => d.getConfig()).reduce((a, b) => ({ ...a, ...b }), {}),
        selectedForm: this.shared.form,
        musts: this.shared.musts,
        scopes: this.shared.scopes
      }
    };
  }
}

export default Form;
